var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Delete_icon",
    "data-name": "Delete icon",
    d: "M12.861,18H5.145a2.063,2.063,0,0,1-2.066-1.878L1.883,4.167H.627a.627.627,0,0,1,0-1.255H5.1V.628A.623.623,0,0,1,5.721,0h6.559A.627.627,0,0,1,12.9.628V2.912h4.471a.627.627,0,0,1,0,1.255H16.117L14.93,16.122A2.067,2.067,0,0,1,12.861,18ZM3.141,4.167h0L4.32,16a.832.832,0,0,0,.82.743h7.725A.818.818,0,0,0,13.68,16L14.861,4.167ZM6.354,1.255h0V2.912h5.295V1.255Z",
    fill: "#f8f8f8",
    opacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconDark);
export default __webpack_public_path__ + "static/media/deleteIconDark.a8043368b1e9bcee93d47613594edbd2.svg";
export { ForwardRef as ReactComponent };